import React, {Component} from 'react';
import { Container,Carousel,Button,Row,Col,Navbar,Nav,NavDropdown } from 'react-bootstrap';
import './all.css'

import './all.css'

class Info extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }


    render() {
        return (
            <Container>
                <Button>123</Button>
            </Container>
        )
    }
}

export default Info;

